module.exports = __webpack_public_path__ + "static/img/cgal9.7a0f51b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/cgal9.png
// module id = 7tVB
// module chunks = 1